<template>
  <div class="main">
    <div class="content_view">
      <div class="title">
        <p>配置任务</p>
        <div></div>
      </div>
    </div>
    <div class="credit_view">
      <div class="credit_item">
        <p>培训完成学分线：</p>
        <el-input
          v-model="passScore"
          placeholder="请输入内容"
          @change="checkRule"
        ></el-input>
        <p>分</p>
      </div>
      <div class="credit_item">
        <p>当前培训总学分：</p>
        <span>{{ countTotalScore() }}分</span>
      </div>
    </div>
    <div class="content_view">
      <ul>
        <li v-for="(item, index) in itemList" :key="index">
          <div
            :class="index == active ? 'active' : ''"
            @click="switchList(item, index)"
          >
            {{ item.label }}
          </div>
        </li>
      </ul>
      <div class="table" v-if="activeList">
        <el-table :data="activeList" style="width: 100%" height="400" border>
          <el-table-column
            prop="itemName"
            width="340"
            :label="itemList[active].label + '名称'"
          >
          </el-table-column>
          <el-table-column prop="name" label="优先级" width="220">
            <template slot-scope="scope">
              <div class="w180">
                <el-select v-model="scope.row.Priority" placeholder="请选择">
                  <el-option label="默认空" :value="Number(99)"></el-option>
                  <el-option
                    v-for="item in PriorityArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="学分">
            <template slot-scope="scope">
              <div class="score_view">
                <div class="score_left">
                  <el-input
                    v-model.number="scope.row.score"
                    maxlength="4"
                    @change="checkScore(scope.row.score, scope.$index)"
                  ></el-input>
                  <p>分</p>
                </div>
                <div class="score_right">
                  <el-radio-group v-model="scope.row.Condition">
                    <el-radio :label="1">
                      {{ btnTxt(itemList[active].label, 0) }}
                    </el-radio>
                    <el-radio :label="2"
                      >{{ btnTxt(itemList[active].label, 1) }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="button_view">
      <div>
        <el-button type="primary" @click="stepPrevious">上一步</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import training from "@/api/trainingApi";
export default {
  data() {
    return {
      itemList: [
        {
          label: "考试",
          type: 0,
          dataListArr: [],
        },
        {
          label: "练习",
          type: 0,
          dataListArr: [],
        },
        {
          label: "课件",
          type: 1,
          dataListArr: [],
        },
        {
          label: "视频",
          type: 1,
          dataListArr: [],
        },
      ],
      label: "考试",
      activeList: [],
      active: 0,
      passScore: 0,
      PriorityArr: [
        {
          label: "低",
          value: 3,
        },
        {
          label: "中",
          value: 2,
        },
        {
          label: "高",
          value: 1,
        },
      ],
    };
  },
  props: ["cutcoms"],
  methods: {
    nextStep() {
      if (this.passScore >= 0) {
        sessionStorage.setItem("stateMenuList", JSON.stringify(this.itemList));
        this.$parent.passScore = this.passScore;
        this.cutcoms(5);
      } else {
        this.$message({
          message: "警告，当前未填写“培训完成学分线”",
          type: "warning",
        });
      }
    },
    stepPrevious() {
      sessionStorage.setItem("stateMenuList", JSON.stringify(this.itemList));
      this.cutcoms(3);
    },
    switchList(item, index) {
      this.active = index;
      this.label = this.itemList[index].label;
      this.activeList = this.itemList[index].dataListArr;
    },
    // 判断当前是否数字
    checkScore(row, index) {
      if (!row) {
        this.activeList[index].score = 0; // 清除当前输入框分数
      }
      if (isNaN(row) == true) {
        this.$message({
          message: "警告，分数必须是数字",
          type: "warning",
        });
        this.activeList[index].score = 0; // 清除当前输入框分数
      }
    },
    // 校验规则
    checkRule() {
      if (!this.passScore) {
        this.passScore = 0;
      }
      if (isNaN(this.passScore) == true) {
        this.$message({
          message: "警告，分数必须是数字",
          type: "warning",
        });
        this.passScore = 0; // 清除当前输入框分数
      }
      if (this.passScore < 0 || this.passScore > this.countTotalScore()) {
        this.$message({
          message: `警告，学分线设置必须大于0且小于总学分${this.countTotalScore()}`,
          type: "warning",
        });
        this.passScore = 0; // 清除当前输入框分数
      }
    },
    async getTraininInfo() {
      let stateMenuList = JSON.parse(sessionStorage.getItem("stateMenuList"));
      const deleteArr = JSON.parse(sessionStorage.getItem("deleteArr"));
      this.itemList = stateMenuList.map((item) => {
        item.dataListArr = item.dataListArr.filter((zitem) => {
          if (deleteArr.includes(zitem.scoreId) == false) {
            return zitem;
          }
        });
        return item;
      });
      console.log(this.itemList, "??? this.itemList", deleteArr);

      this.activeList = this.itemList[0].dataListArr;
    },
  },
  computed: {
    btnTxt() {
      return function (row, type) {
        console.log(row, type);
        if ((row == "考试" || row == "练习") && type == 0) {
          return `完成${row}获取学分`;
        } else if ((row == "考试" || row == "练习") && type == 1) {
          return `进行${row}获取学分`;
        } else if ((row == "课件" || row == "视频") && type == 0) {
          return `看过${row}获取学分`;
        } else if ((row == "课件" || row == "视频") && type == 1) {
          return `看完${row}获取学分`;
        }
      };
    },
    countTotalScore() {
      return function () {
        let num = 0;
        console.log(this.itemList);
        this.itemList.forEach((item) => {
          item.dataListArr.forEach((zitem) => {
            num += zitem.score;
          });
        });
        return num;
      };
    },
  },
  activated() {
    this.getTraininInfo();
    this.passScore = this.$parent.passScore;
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  min-height: 780px;
  position: relative;
  .content_view {
    padding: 24px;
  }
  .title {
    display: flex;
    align-items: center;
    > p {
      font-size: 22px;
      margin-right: 24px;
    }
    > div {
      border-bottom: 1px solid #e3e6eb;
      width: 50%;
      height: 1px;
    }
  }
  .button_view {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 4%;
    // margin-top: 12%;
    > div {
      display: flex;
      padding: 16px;
      > .el-button {
        width: 120px;
        margin-right: 16px;
      }
    }
  }
}
ul {
  list-style-type: none;
  display: flex;
  align-items: center;
  > li {
    > div {
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #f2f2f2;
      letter-spacing: 2px;
    }
  }
}
.active {
  background: #0052d9;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
}
.table {
  padding: 24px;
}
::v-deep .cell {
  text-align: center;
}
.score_view {
  display: flex;
  justify-content: space-around;
  align-items: center;
  > .score_left {
    display: flex;
    align-items: center;
    > .el-input {
      width: 70px !important;
    }
    > p {
      margin-left: 24px;
    }
  }
  .score_right {
    display: flex;
    flex-direction: column;
  }
}
.w180 {
  ::v-deep .el-input__inner {
    width: 120px;
  }
}
.credit_view {
  padding: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  .credit_item {
    display: flex;
    height: 50px;
    align-items: center;
    margin-right: 80px;
    > ::v-deep .el-input {
      width: 50px;
      margin: 0px 8px;
    }
  }
}
</style>